export default __webpack_public_path__ + "static/media/add_note.d002e62e.svg";